import { render } from "./ProductsAwaitingApproval.vue?vue&type=template&id=16f5aa08&scoped=true"
import script from "./ProductsAwaitingApproval.vue?vue&type=script&lang=js"
export * from "./ProductsAwaitingApproval.vue?vue&type=script&lang=js"

import "./ProductsAwaitingApproval.vue?vue&type=style&index=0&id=16f5aa08&lang=scss&scoped=true"
import "./ProductsAwaitingApproval.vue?vue&type=style&index=1&id=16f5aa08&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f5aa08"]])

export default __exports__